module.exports = __webpack_public_path__ + "media/images/clickworker_com/clickworker_werben-6cbeab3308990ee9b8129b8bbc8dc5f4.png";